import { Box, Input, InputLabel, Typography } from "@material-ui/core";
import React from "react";
import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import { useSelector } from "react-redux";
import { Constant } from "../../Constant";
import { isEmpty, isNotEmpty, isObjectNotEmpty } from "../../Utils";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import { getForm } from "../../redux/selector";
import "./CustomHKID.scss";
export default function CustomHKID({
    label = "",
    control,
    name,
    showError = true,
    required = true,
    onChange = () => {},
    onBlur = () => {},
    disabled = false,
    shrink = false,
    hkicOnly = false,
    displayColon = true,
    clearErrors = () => {},
}) {
    const autofillOffList = Constant.autoCompleteOffList;
    const { formId } = useSelector(getForm());
    const isAutofillOff = autofillOffList.includes(formId);
    const { field, fieldState } = useController({
        name,
        control,
    });
    const hkid = isNotEmpty(field.value) ? field.value.split("(")[0] : "";
    const checkDigit = isNotEmpty(field.value)
        ? field.value.split("(")[1]?.split(")")[0]
        : "";
    const { t, i18n } = useTranslation();

    return (
        <Box className="hkId">
            {!isEmpty(label) && (
                <Box mb={4}>
                    <InputLabel
                        disabled={disabled}
                        shrink={shrink}
                        error={isNotEmpty(fieldState.error)}
                        htmlFor={name}
                    >
                        <Box>
                            {label}
                            {displayColon &&
                                (i18n.language === "en" ? ":" : "：")}
                            {required && (
                                <Box component="span" className="danger">
                                    *
                                </Box>
                            )}
                        </Box>
                    </InputLabel>
                </Box>
            )}
            <Box className="hkId-input">
                <InputMask
                    mask="a*999999"
                    maskChar={null}
                    value={hkid}
                    onChange={(event) => {
                        let value = event.target.value;
                        value = value?.toUpperCase();
                        field.onChange(
                            hkicOnly ? `${value}` : `${value}(${checkDigit})`
                        );
                        onChange(
                            hkicOnly ? `${value}` : `${value}(${checkDigit})`
                        );
                    }}
                    onBlur={() => {
                        field.onBlur();
                        onBlur();
                    }}
                    onFocus={() => {
                        clearErrors(name);
                    }}
                    beforeMaskedValueChange={(newState, oldState) => {
                        if (
                            isNotEmpty(newState.value[1]) &&
                            newState.value[1] >= "0" &&
                            newState.value[1] <= "9" &&
                            newState.value.length >= 8
                        ) {
                            return oldState;
                        } else {
                            return newState;
                        }
                    }}
                    disabled={disabled}
                >
                    {(inputProps) => (
                        <InputLabel className="inline-input">
                            <p className="hidden">{t("common.portal.hkid")}</p>
                            <Input
                                inputProps={{
                                    "aria-labelledby": name,
                                    ...inputProps,
                                }}
                                id={name}
                                error={isObjectNotEmpty(fieldState?.error)}
                                placeholder="X999999"
                                disabled={disabled}
                                inputRef={field.ref}
                                autoComplete={isAutofillOff ? "off" : "on"}
                            />
                        </InputLabel>
                    )}
                </InputMask>
                {!hkicOnly && (
                    <Typography>
                        (
                        <InputMask
                            mask="9"
                            formatChars={{
                                9: "[0-9aA]",
                            }}
                            maskChar={null}
                            value={checkDigit}
                            onChange={(event) => {
                                let value = event.target.value;
                                value = value?.toUpperCase();
                                field.onChange(`${hkid}(${value})`);
                                onChange(`${hkid}(${value})`);
                            }}
                            onBlur={() => {
                                field.onBlur();
                                onBlur();
                            }}
                            disabled={disabled}
                            onFocus={() => {
                                clearErrors(name);
                            }}
                        >
                            {(inputProps) => (
                                <InputLabel className="inline-input">
                                    <p className="hidden">
                                        {t("common.portal.hkid_brackets")}
                                    </p>
                                    <Input
                                        {...inputProps}
                                        error={isObjectNotEmpty(
                                            fieldState?.error
                                        )}
                                        placeholder="X"
                                        style={{
                                            width: "14px",
                                        }}
                                        inputProps={{
                                            style: { textAlign: "center" },
                                        }}
                                        disabled={disabled}
                                        autoComplete={
                                            isAutofillOff ? "off" : "on"
                                        }
                                    />
                                </InputLabel>
                            )}
                        </InputMask>
                        )
                    </Typography>
                )}
            </Box>
            {showError && <ErrorMsg message={fieldState?.error?.message} />}
        </Box>
    );
}
